import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import * as actions from './actions';
import * as selectors from './selectors';
import { clearAndGetFilters, setInitialFilters } from './../filters/operations';
import { initialFilterSelector } from './../general/selectors';
import { ACTIVITY_REQUEST_TYPES, META_SKIP_ERROR_PAGE } from '../../constants';
import { prepareActivityRequests } from '../../util';
import * as generalActions from './../general/actions';

import { operations } from './';

export const requestActivity = (params, meta) => (dispatch) => {
  switch (params.type) {
    case ACTIVITY_REQUEST_TYPES.SCOPE_ORG_XTM: {
      return dispatch(actions.fetchOrganizationActivity(params, meta));
    }
    case ACTIVITY_REQUEST_TYPES.SCOPE_ORG_USER: {
      return dispatch(actions.getUserActivity({
        ...params,
        level: 'organization',
      }));
    }
    case ACTIVITY_REQUEST_TYPES.SCOPE_MYSELF:
    case ACTIVITY_REQUEST_TYPES.OWNERS_USER: {
      return dispatch(actions.getUserActivity(params, meta));
    }
    case ACTIVITY_REQUEST_TYPES.SCOPE_MYTEAM:
    case ACTIVITY_REQUEST_TYPES.OWNERS_TEAM: {
      return dispatch(actions.getTeamActivity(params, meta));
    }
    default:
      return Promise.resolve();
  }
};

export const fetchActivities = (activities, meta) => async (dispatch) => {
  dispatch(actions.getUserActivityRequest());
  if (!activities) {
    return dispatch(actions.getUserActivityFailure());
  }

  const waitList = activities.slice(2);
  const activitiesTracker = activities.slice(0, 2);
  const activeRequests = activitiesTracker.map((queryParams) => (
    dispatch(operations.requestActivity(queryParams, meta))
  ));

  while (activeRequests.length) {
    // eslint-disable-next-line no-await-in-loop
    await Promise.race(activeRequests).then((result) => {
      const nextQueryParams = waitList.pop();
      const index = activitiesTracker.findIndex(({ username }) => (
        result && username === result.username
      ));

      activitiesTracker.splice(index, 1);
      activeRequests.splice(index, 1);
      if (nextQueryParams) {
        activitiesTracker.push(nextQueryParams);
        activeRequests.push(
          dispatch(operations.requestActivity(nextQueryParams, meta)),
        );
      }
    });
  }
  return dispatch(actions.fetchUsersActivityComplete());
};

export const updateConcurrencyData = ({
  meta = META_SKIP_ERROR_PAGE,
} = {}) => (dispatch, getState) => {
  const params = selectors.activityParamsSelector(getState());
  return dispatch(operations.fetchActivities(prepareActivityRequests(params), meta));
};

export const loadInitData = (options) => (dispatch, getState) => (
  dispatch(generalActions.loadInitData(
    Promise.all([
      dispatch(clearAndGetFilters()),
      dispatch(setInitialFilters(...initialFilterSelector(getState()))),
    ]).then(() => dispatch(operations.updateConcurrencyData(options)))
      .catch((error) => {
        dispatch(notificationActions.notifyDanger(
          error.message, 'We\'ve experienced an issue while loading data.', true,
        ));
      }),
  )));
